import {BasicBitmapCountUp, BitmapTextStyleOptions} from "./BasicBitmapCountUp";
import {BetWayWins} from "../server/BenjiKIVData";
import {BenjiKIVSound} from "../sound/BenjiKIVSound";
import {BenjiKIV} from "../BenjiKIV";

export class Multiplier extends BasicBitmapCountUp {
    private _soundTimeOut: NodeJS.Timeout | undefined;
    private _bigWinLevel: number = 0;
    private _level5SoundPlayed: boolean;

    constructor(style: BitmapTextStyleOptions, maxWidth: number, anchor: PIXI.Point) {
        super(style, maxWidth, anchor);
    }

    private _defaultScale: number = 1;

    set defaultScale(value: number) {
        this._defaultScale = value;

        this.scale.set(value);
    }

    private _startPoint: number;

    set startPoint(value: number) {
        this._startPoint = value;
    }

    private _data: BetWayWins;

    set data(value: BetWayWins) {
        this.visible = false;

        this._data = value;
        this._value = 1;

        this.forceSetText("x2");

        this._bigWinLevel = 0;
        this._level5SoundPlayed = false;
    }

    private _value: number;

    private set value(value: number) {
        const prevValue: number = this._value;

        this._value = value;
        this.forceSetText("x" + value);

        // #227
        if (!this._level5SoundPlayed && this._bigWinLevel === 5 && ((this._data.multiplier - this._value) > 100)) {
            BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MULTIPLIER_COUNT_UP_BIG);
            this._level5SoundPlayed = true;
            this._soundTimeOut = undefined;
        } else {
            if (!this._soundTimeOut) {
                this._soundTimeOut = setTimeout(() => {
                    BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MULTIPLIER_COUNT_UP.next());

                    this._soundTimeOut = undefined;
                }, 50);
            }
        }

        if (this._maxWidth && this._amountText.width > this._maxWidth) {
            this.setScaleToFitMaxWidth(prevValue, value);
            this.forceSetText("x" + value);
        } else {
            this.scale.set(this._defaultScale + 0.3);
        }
    }

    public onBigWinLevelChange(level: number): void {
        this._bigWinLevel = level;
    }

    public update(amount: number): void {
        if (amount > this._startPoint && this._value <= this._data.multiplier) {
            const multiplier: number = Math.ceil((amount - this._startPoint) / this._data.amount);

            if (multiplier >= 2 && multiplier !== this._value && multiplier <= this._data.multiplier) {
                this.value = multiplier;

                const betWayWins: BetWayWins[] = BenjiKIV.model.gameData.betWayWins;
                let onCount: number = 0,
                    totalMultipliers: number = 0,
                    firstIndex: number = -1;
                for (let i: number = 0; i < betWayWins.length; i++) {
                    if (firstIndex === -1 && betWayWins[i].multiplier > 1) {
                        firstIndex = i;
                    }
                    if (BenjiKIV.multiplierCountUp.multipliers[i].visible) {
                        onCount++;
                    }

                    if (betWayWins[i].multiplier > 1) {
                        totalMultipliers++;
                    }
                }
                if (onCount === 0 && this._data && this._startPoint >=0 && this._data.multiplier !== 1) {
                    BenjiKIV.multiplierCountUp.show1Multiplier(firstIndex);
                } else if (onCount === 1 && totalMultipliers !== 1) {
                    if (this._data && this._startPoint && this._data.multiplier !== 1 && amount >= this._startPoint && amount >= BenjiKIV.multiplierCountUp.multipliers[firstIndex + 1]._startPoint) {
                        BenjiKIV.multiplierCountUp.show2Multipliers(firstIndex);
                    }
                } else if (onCount === 2 && totalMultipliers === 3) {
                    if (this._data && this._startPoint && this._data.multiplier !== 1 && amount >= BenjiKIV.multiplierCountUp.multipliers[2]._startPoint) {
                        BenjiKIV.multiplierCountUp.show3Multipliers();
                    }
                }
            } else if (this.scale.x !== this._defaultScale && multiplier > 2 && multiplier === this._data.multiplier + 1) {
                this.scale.set(this._defaultScale);
            }
        }
    }

    public setAmountTextScale(): void {
        this._amountText.scale.set(1);
    }

    public setAmountTextScaleOnSummary(): void {
        const prevValue: number = this._value;

        if (this._maxWidth && this._amountText.width > this._maxWidth) {
            this.setScaleToFitMaxWidth(prevValue, prevValue);
            this.forceSetText("x" + prevValue);
        }
    }
}